/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { FancyContainer } from '@appCanvasCommon/graphics/FancyContainer';
import { FancyText } from '@appCanvasCommon/fontpath/FancyText';
import { HighResolutionText } from '@appCanvasCommon/text/HighResolutionText';

import { InsertionPointLabelHighResolutionText } from './InsertionPointLabel';
import {
	INSERTION_POINT_LABEL_STYLE,
	INSERTION_POINT_TEXT_CONFIGURATION,
} from './InsertionPointConfiguration';

export interface InsertionPointLabelContainerConfiguration {
	x: number;
}

export interface InsertionPointLabelTextConfiguration {
	fontSize: number;
	fill: number;
	fontFamily: string;
}

/**
 * This class creates a new container to organize the elements of the Insertion Point label, including the text and icon.
 */
export class InsertionPointLabelContainer extends FancyContainer {
	private _labelText: FancyText | HighResolutionText;
	constructor(text: string, configuration: InsertionPointLabelContainerConfiguration) {
		super();
		this.init(text, configuration);
	}

	public override destroy(): void {
		this._labelText.destroy();
		super.destroy();
	}

	public update(configuration: InsertionPointLabelContainerConfiguration): void {
		this.x = configuration.x;
	}

	private init(text: string, initialConfiguration: InsertionPointLabelContainerConfiguration): void {
		// Static configuration
		this.visible = true;
		this.y = INSERTION_POINT_LABEL_STYLE.paddingTop;
		// Dynamic configuration
		this.x = initialConfiguration.x;

		// BEGIN PLACEHOLDER REPLACE AS PART OF TP-5862
		// TODO: figure out why InsertionPointLabelFancyText is not working. https://mocasystems.atlassian.net/browse/TP-5862
		// if (planRendererInfo.isWebGL()) {
		// 	this._labelText = new InsertionPointLabelFancyText(text, initialConfiguration);
		// } else {
		// 	this._labelText = new InsertionPointLabelHighResolutionText(text, initialConfiguration);
		// }
		this._labelText = new InsertionPointLabelHighResolutionText(text, INSERTION_POINT_TEXT_CONFIGURATION);
		// END PLACEHOLDER REPLACE AS PART OF TP-5862

		this.addChild(this._labelText);
	}
}
